import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=5b386550&"
import script from "./Step1.vue?vue&type=script&lang=ts&"
export * from "./Step1.vue?vue&type=script&lang=ts&"
import style0 from "./Step1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports